import { shuffleArray } from 'utils/arrayUtils';

/** Item IDs in display order for this page visit; reset on full reload. */
let visitOrderIds = null;

/**
 * Filters out sold-out GWP items and randomizes order once per page visit.
 * Carousel and modal share the same order until the in-stock set changes or the page reloads.
 *
 * @param {Array<{ id: number, soldOut?: boolean }>} items - Raw GWP items from the API
 * @returns {Array} In-stock items in randomized display order
 */
export function getSortedInStockGiftWithPurchaseItems(items) {
    const inStockItems = items.filter((item) => !item.soldOut);

    if (inStockItems.length === 0) {
        visitOrderIds = null;
        return [];
    }

    const inStockById = new Map(inStockItems.map((item) => [item.id, item]));

    if (
        visitOrderIds &&
        visitOrderIds.length === inStockItems.length &&
        visitOrderIds.every((id) => inStockById.has(id))
    ) {
        return visitOrderIds.map((id) => inStockById.get(id));
    }

    const shuffled = shuffleArray(inStockItems);
    visitOrderIds = shuffled.map((item) => item.id);
    return shuffled;
}
